import { inject, observer } from 'mobx-react'
import React, { useState } from 'react'
import { Transition } from 'semantic-ui-react'
import styled from 'styled-components'
import WalletIcon from '../Icons/WalletIcon'
import { BoldText, TooltipBody } from './UsersBalance'

const SalesPerUserContainer = styled.div`
  display: flex;
  margin-left: 20px
`
const SalesPerUser = ({ store }) => {
  const [visible, setVisible] = useState(false)
  const { salesPerUser } = store.conversation

  return (
    <SalesPerUserContainer
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <WalletIcon/>
      <BoldText>{salesPerUser || 0}</BoldText>
      <Transition visible={visible} animation='slide down' duration={100}>
        <TooltipBody>
          Total amount of purchases user did on this site.
        </TooltipBody>
      </Transition>
    </SalesPerUserContainer>
  )
}

export default inject('store',)(observer(SalesPerUser))
